import type { AttrSchema } from "@easysaas/widget-core";

/** Single source of truth for this widget's data-attributes.
 *  Used both at runtime (defineWidget) and at build time (configurator-page generator
 *  in scripts/post-build.ts). UI hints (label, group, step, min) are optional and
 *  ignored by the runtime parser. */
export const attrs = {
  currency: {
    type: "string",
    default: "EUR",
    label: "Währung (ISO-Code)",
    group: "Anzeige",
  },
  ourRate: {
    type: "number",
    default: 1.5,
    label: "easyWerkstatt-Rate (%)",
    group: "Anzeige",
    step: 0.05,
    min: 0,
  },
  monthlyVolume: {
    type: "number",
    default: 4000,
    label: "Volumen pro Monat (€)",
    group: "Volumen",
    step: 100,
    min: 0,
  },
  monthlyTransactions: {
    type: "number",
    default: 10,
    label: "Anzahl Zahlungen pro Monat",
    group: "Volumen",
    step: 1,
    min: 0,
  },
  privateDebitPercent: {
    type: "number",
    default: 0.79,
    label: "Privat Debit (%)",
    group: "Zahlungsgebühren",
    step: 0.01,
    min: 0,
  },
  privateDebitShare: {
    type: "number",
    default: 50,
    label: "Privat Debit Anteil (%)",
    group: "Zahlungsgebühren",
    step: 1,
    min: 0,
  },
  privateCreditPercent: {
    type: "number",
    default: 0.79,
    label: "Privat Kredit (%)",
    group: "Zahlungsgebühren",
    step: 0.01,
    min: 0,
  },
  privateCreditShare: {
    type: "number",
    default: 40,
    label: "Privat Kredit Anteil (%)",
    group: "Zahlungsgebühren",
    step: 1,
    min: 0,
  },
  businessPercent: {
    type: "number",
    default: 1.39,
    label: "Business (%)",
    group: "Zahlungsgebühren",
    step: 0.01,
    min: 0,
  },
  businessShare: {
    type: "number",
    default: 10,
    label: "Business Anteil (%)",
    group: "Zahlungsgebühren",
    step: 1,
    min: 0,
  },
  paymentFixed: {
    type: "number",
    default: 0,
    label: "Fixgebühr je Zahlung (€)",
    group: "Zahlungsgebühren",
    step: 0.01,
    min: 0,
  },
  payoutFixed: {
    type: "number",
    default: 0,
    label: "Fixgebühr je Auszahlung (€)",
    group: "Auszahlung & Handling",
    step: 0.05,
    min: 0,
  },
  payoutPercent: {
    type: "number",
    default: 0,
    label: "Prozentgebühr je Auszahlung (%)",
    group: "Auszahlung & Handling",
    step: 0.05,
    min: 0,
  },
  payoutsPerMonth: {
    type: "number",
    default: 22,
    label: "Anzahl Auszahlungen pro Monat",
    group: "Auszahlung & Handling",
    step: 1,
    min: 0,
  },
  threeDsFee: {
    type: "number",
    default: 0,
    label: "3DS-Handling-Gebühr (€/Zahlung)",
    group: "Auszahlung & Handling",
    step: 0.01,
    min: 0,
  },
  accountMonthly: {
    type: "number",
    default: 0,
    label: "Konto-/Account-Plan (€/Monat)",
    group: "Monatliche Kosten",
    step: 1,
    min: 0,
  },
  terminalMonthly: {
    type: "number",
    default: 0,
    label: "Terminal-Hardware (€/Monat)",
    group: "Monatliche Kosten",
    step: 1,
    min: 0,
  },
} as const satisfies AttrSchema;
